<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <div class="row">          
                        <div class="col-lg-12 col-xs-12 col-xl-6">
                            <p class="page-text margin-bottom-15">
                                Acompanhe abaixo os relatórios e métricas. Toque na opção desejada para visualizar.
                            </p>
                        </div>                                 
                        <div class="col-xl-12 margin-bottom-20 menu">
                            
                            <a class="button block-mobile small" v-on:click="setTab('metricas')" v-bind:class="{'transparent': tab != 'metricas', 'color-primary': tab == 'metricas'}">
                                <i class="material-icons">folder_special</i>
                                Principais métricas
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('faturamento-mes')" v-bind:class="{'transparent': tab != 'faturamento-mes', 'color-primary': tab == 'faturamento-mes'}">
                                <i class="material-icons">timeline</i>
                                Faturamento mensal
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('satisfacao-pacientes')" v-bind:class="{'transparent': tab != 'satisfacao-pacientes', 'color-primary': tab == 'satisfacao-pacientes'}">
                                <i class="material-icons">thumb_up</i>
                                Satisfação dos pacientes
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('receita-despesas')" v-bind:class="{'transparent': tab != 'receita-despesas', 'color-primary': tab == 'receita-despesas'}">
                                <i class="material-icons">attach_money</i>
                                Receita / Despesas
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('relatorio-exemplo')" v-bind:class="{'transparent': tab != 'relatorio-exemplo', 'color-primary': tab == 'relatorio-exemplo'}">
                                <i class="material-icons">view_agenda</i>
                                Relatório exemplo X
                            </a>

                            <a class="button block-mobile small" v-on:click="setTab('relatorio-exemplo-2')" v-bind:class="{'transparent': tab != 'relatorio-exemplo-2', 'color-primary': tab == 'relatorio-exemplo-2'}">
                                <i class="material-icons">view_week</i>
                                Relatório exemplo Y
                            </a>                            

                           

                        </div>  

                        <div class="col-xl-12 scroll-to"></div>

                        <div class="col-xl-12 margin-top-10 margin-bottom-20" v-show="tab == 'metricas'">
                            <hr>
                            <div class="row">
                                <div class="col-xl-12 margin-bottom-15 margin-top-10 center">
                                    <h3>
                                        <i class="material-icons">folder_special</i>
                                        Principais métricas
                                    </h3>
                                </div>
                                <div class="col-xl-12 col-xs-12 col-lg-12">
                                    <div class="row">
                                        <div class="col-xs-12 col-xl-3 col-lg-6 col-md-6">
                                            <div class="button-menu shadow">
                                                <h1>R$ 34.232,00</h1>
                                                Receita mensal
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>252</h1>
                                                Consultas no mês
                                            </div>     
                                        </div>    
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>14</h1>
                                                Consultas hoje
                                            </div>    
                                        </div>    
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>78</h1>
                                                Consultas esta semana
                                            </div>    
                                        </div>  
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>45</h1>
                                                Consultas agendadas
                                            </div>  
                                        </div>  
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>54.223</h1>
                                                Pacientes cadastrados
                                            </div>                                                                             
                                        </div>  
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>123</h1>
                                                Métrica exemplo X
                                            </div>                                                                             
                                        </div>
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>56</h1>
                                                Métrica exemplo Y
                                            </div>                                                                             
                                        </div> 
                                        <div class="col-xs-6 col-xl-3 col-lg-4">
                                            <div class="button-menu shadow">
                                                <h1>1</h1>
                                                Métrica exemplo Z
                                            </div>                                                                             
                                        </div>                                                                                         
                                    </div>  
                                </div>
                            </div>
                        </div> 

                        <div class="col-xl-12 margin-top-10 margin-bottom-20" v-show="tab == 'faturamento-mes'">
                            <hr>
                            <div class="row">
                                <div class="col-xl-12 margin-bottom-15 margin-top-10 center">
                                    <h3>
                                        <i class="material-icons">timeline</i>
                                        Faturamento mensal
                                    </h3>
                                    <h5>
                                        <i class="material-icons">compare_arrows</i>
                                        Deslize para lados no gráfico abaixo e visualize todas as informações.
                                    </h5>
                                </div>
                                <div class="col-xl-12 col-xs-12 col-lg-12 " style="overflow-x: scroll">
                                    <div class="chart" id="chartdiv" style="width: 600px; height: 300px; background-color: #FFFFFF;" ></div>
                                </div>
                            </div>
                        </div>      

                        <div class="col-xl-12 margin-top-10 margin-bottom-20" v-show="tab == 'satisfacao-pacientes'">
                            <hr>
                            <div class="row">
                                <div class="col-xl-12 margin-bottom-15 margin-top-10 center">
                                    <h3>
                                        <i class="material-icons">thumb_up</i>
                                        Satisfação dos pacientes
                                    </h3>
                                    <h5>
                                        <i class="material-icons">compare_arrows</i>
                                        Deslize para lados no gráfico abaixo e visualize todas as informações.
                                    </h5>                                    
                                </div>
                                <div class="col-xl-12 col-xs-12 col-lg-12" style="overflow-x: scroll">
                                    <div class="chart" id="chartdiv2" style="width: 600px; height: 300px; background-color: #FFFFFF;" ></div>

                                </div>
                            </div>
                        </div>      

                        <div class="col-xl-12 margin-top-10 margin-bottom-20" v-show="tab == 'receita-despesas'">
                            <hr>
                            <div class="row">
                                <div class="col-xl-12 margin-bottom-15 margin-top-10 center">
                                    <h3>
                                        <i class="material-icons">attach_money</i>
                                        Receita / Despesas
                                    </h3>
                                    <h5>
                                        <i class="material-icons">compare_arrows</i>
                                        Deslize para lados no gráfico abaixo e visualize todas as informações.
                                    </h5>                                    
                                </div>
                                <div class="col-xs-12" style="overflow-x: scroll;">
                                    <div class="chart" id="chartdiv3" style="width: 600px; height: 300px; background-color: #FFFFFF;" ></div>
                                </div>
                            </div>
                        </div>      

                        <div class="col-xl-12 margin-top-10 margin-bottom-20" v-show="tab == 'relatorio-exemplo'">
                            <hr>
                            <div class="row">
                                <div class="col-xl-12 margin-bottom-15 margin-top-10 center">
                                    <h3>
                                        <i class="material-icons">view_agenda</i>
                                        Relatório exemplo X
                                    </h3>
                                    <h5>
                                        <i class="material-icons">compare_arrows</i>
                                        Deslize para lados na tabela abaixo e visualize todas as informações.
                                    </h5>                                    
                                </div>
                                <div class="col-xl-12 col-xs-12 col-lg-12" style="overflow-x: scroll;">
                                    <div class="table-scroll">
                                        <table class="table table-bordered table-bordered-default">
                                            <thead>
                                                <th style="min-width: 60px; width: 60px;">
                                                    #
                                                </th>
                                                <th style="min-width: 140px; width: 140px;">
                                                    Coluna exemplo 1
                                                </th>               
                                                <th style="min-width: 150px; width: 150px;">
                                                    Coluna exemplo 2
                                                </th>
                                                <th style="min-width: 150px; width: 150px;">
                                                    Coluna 3
                                                </th>               
                                                <th style="min-width: 300px; width: 300px;">
                                                    Exemplo
                                                </th>      
                                                <th style="min-width: 170px; width: 170px;">
                                                    Coluna Testes
                                                </th>                                                                               
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        1
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>  
                                                <tr>
                                                    <td>
                                                        2
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>   
                                                <tr>
                                                    <td>
                                                        3
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        4
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>  
                                                <tr>
                                                    <td>
                                                        5
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td>
                                                        6
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>   
                                                <tr>
                                                    <td>
                                                        7
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        8
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>     
                                                <tr>
                                                    <td>
                                                        9
                                                    </td>
                                                    <td>
                                                        Exemplo
                                                    </td>
                                                    <td>
                                                        Demonstração
                                                    </td>
                                                    <td>
                                                        Demonstração 2
                                                    </td>
                                                    <td>
                                                        Testes
                                                    </td>
                                                    <td>
                                                        Valor exemplo
                                                    </td>
                                                </tr>                                                                          
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>      

                        <div class="col-xl-12 margin-top-10 margin-bottom-20" v-show="tab == 'relatorio-exemplo-2'">
                            <hr>
                            <div class="row">
                                <div class="col-xl-12 margin-bottom-15 margin-top-10 center">
                                    <h3>
                                        <i class="material-icons">view_week</i>
                                        Relatório exemplo Y
                                    </h3>
                                    <h5>
                                        <i class="material-icons">compare_arrows</i>
                                        Deslize para lados no gráfico abaixo e visualize todas as informações.
                                    </h5>                                    
                                </div>
                                <div class="col-xl-12 col-xs-12 col-lg-12" style="overflow-x: scroll;">
                                    <div class="chart" id="chartdiv4" style="width: 500px; height: 400px; background-color: #FFFFFF;" ></div>
                                    <div class="chart" id="chartdiv5" style="width: 600px; height: 300px; background-color: #FFFFFF;" ></div>
                                </div>
                            </div>
                        </div>                                                                                                                         

                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Relatorios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    watch: {
  
    },    
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  "metricas",
            "data":                 {
                "itens":            []
            },                              
            "loading": {
                "submit":           false
            },      
            "form": {
                "_cod":             self.$root.user.cod,
                "empresaCod":       "",
                "estoqueCod":       "",
                "catalogoCod":      "",
                "mes":              (new Date().getMonth()+1),
                "ano":              (new Date().getFullYear()),                
            },
        }
    },
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            if (self.tab == tab) return false;
            self.tab        = tab;
            loading.show();
            $(".dashboard-content-inner")[0].scrollTo({
                top: 5
            });  
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top:            $(".scroll-to")[0].getBoundingClientRect().top - 60,
                    behavior:       "smooth"
                });             
                setTimeout(function() {
                    loading.hide();
                }, 200);
            }, 200);
        },                           
    },
    created: function() {
        var self = this;

        loading.hide();

        // if (self.$root.user.tipo == "prestador") {
        //     self.form.empresaCod = self.$root.user.empresaCod;
        // }


        // var date                = new Date();
        // var firstDay            = new Date(date.getFullYear(), date.getMonth(), 1);
        // var lastDay             = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        // self.form.dataInicio    = firstDay.toISOString().split("T")[0];
        // self.form.dataFinal     = lastDay.toISOString().split("T")[0];

        // Promise.all([
        //     // self.get(),
        //     self.getEstoque(),
        //     self.getEmpresas(),
        //     self.getCatalogo(),
        // ]).then(function() {
        
        //     loading.hide();
            
        // }).catch(function(error) {
        //     loading.hide();
        // });         

    },
    mounted: function() {
        AmCharts.makeChart("chartdiv",
            {
                "type": "serial",
                "categoryField": "category",
                "autoMarginOffset": 10,
                "marginRight": 10,
                "marginTop": 10,
                "startDuration": 1,
                "fontSize": 13,
                "theme": "light",
                "categoryAxis": {
                    "gridPosition": "start"
                },
                "trendLines": [],
                "graphs": [
                    {
                        "balloonText": "[[title]] of [[category]]:[[value]]",
                        "bullet": "round",
                        "bulletSize": 10,
                        "id": "AmGraph-1",
                        "lineAlpha": 1,
                        "lineThickness": 3,
                        "title": "graph 1",
                        "type": "smoothedLine",
                        "valueField": "column-1"
                    }
                ],
                "guides": [],
                "valueAxes": [
                    {
                        "id": "ValueAxis-1",
                        "title": ""
                    }
                ],
                "allLabels": [],
                "balloon": {},
                "titles": [],
                "dataProvider": [
                    {
                        "category": "Janeiro",
                        "column-1": "0",
                        "column-2": 5
                    },
                    {
                        "category": "Fevereiro",
                        "column-1": "1",
                        "column-2": 7
                    },
                    {
                        "category": "Março",
                        "column-1": 2,
                        "column-2": 3
                    },
                    {
                        "category": "Abril",
                        "column-1": 1,
                        "column-2": 3
                    },
                    {
                        "category": "Maio",
                        "column-1": 2,
                        "column-2": 1
                    },
                    {
                        "category": "Junho",
                        "column-1": 3,
                        "column-2": 2
                    },
                    {
                        "category": "Julho",
                        "column-1": 6,
                        "column-2": 8
                    }
                ]
            }
        );
        AmCharts.makeChart("chartdiv2",
            {
                "type": "serial",
                "categoryField": "category",
                "rotate": true,
                "autoMarginOffset": 10,
                "marginRight": 10,
                "marginTop": 10,
                "plotAreaBorderColor": "#320E0E",
                "startDuration": 1,
                "fontSize": 13,
                "theme": "light",
                "categoryAxis": {
                    "gridPosition": "start"
                },
                "trendLines": [],
                "graphs": [
                    {
                        "balloonText": "[[title]] of [[category]]:[[value]]",
                        "fillAlphas": 1,
                        "id": "AmGraph-1",
                        "labelText": "",
                        "title": "graph 1",
                        "type": "column",
                        "valueField": "column-1"
                    },
                    {
                        "balloonText": "[[title]] of [[category]]:[[value]]",
                        "bullet": "round",
                        "id": "AmGraph-2",
                        "labelText": "",
                        "lineThickness": 2,
                        "title": "graph 2",
                        "valueField": "column-2"
                    }
                ],
                "guides": [],
                "valueAxes": [
                    {
                        "id": "ValueAxis-1",
                        "title": ""
                    }
                ],
                "allLabels": [],
                "balloon": {},
                "titles": [],
                "dataProvider": [
                    {
                        "category": "Nota 1",
                        "column-1": "33"
                    },
                    {
                        "category": "Nota 2",
                        "column-1": "51"
                    },
                    {
                        "category": "Nota 3",
                        "column-1": "48"
                    },
                    {
                        "category": "Nota 4",
                        "column-1": "97"
                    },
                    {
                        "category": "Nota 5",
                        "column-1": "110"
                    }
                ]
            }
        );          
        AmCharts.makeChart("chartdiv3",
            {
                "type": "serial",
                "categoryField": "category",
                "autoMarginOffset": 10,
                "marginRight": 10,
                "marginTop": 10,
                "startDuration": 1,
                "fontSize": 13,
                "theme": "patterns",
                "categoryAxis": {
                    "gridPosition": "start"
                },
                "trendLines": [],
                "graphs": [
                    {
                        "balloonText": "[[title]] of [[category]]:[[value]]",
                        "fillAlphas": 0.9,
                        "id": "AmGraph-1",
                        "title": "graph 1",
                        "type": "column",
                        "valueField": "column-1"
                    },
                    {
                        "balloonText": "[[title]] of [[category]]:[[value]]",
                        "fillAlphas": 0.9,
                        "id": "AmGraph-2",
                        "title": "graph 2",
                        "type": "column",
                        "valueField": "column-2"
                    }
                ],
                "guides": [],
                "valueAxes": [
                    {
                        "id": "ValueAxis-1",
                        "title": "Exemplo"
                    }
                ],
                "allLabels": [],
                "balloon": {},
                "titles": [],
                "dataProvider": [
                    {
                        "category": "1",
                        "column-1": 1,
                        "column-2": 3
                    },
                    {
                        "category": "2",
                        "column-1": 6,
                        "column-2": 7
                    },
                    {
                        "category": "3",
                        "column-1": 2,
                        "column-2": 3
                    }
                ]
            }
        );   
        AmCharts.makeChart("chartdiv4",
            {
                "type": "pie",
                "balloonText": "[[title]]<br><span style='font-size:14px'><b>[[value]]</b> ([[percents]]%)</span>",
                "titleField": "country",
                "valueField": "litres",
                "fontSize": 12,
                "theme": "light",
                "allLabels": [],
                "balloon": {},
                "titles": [],
                "dataProvider": [
                    {
                        "country": "Teste 1",
                        "litres": "356.9"
                    },
                    {
                        "country": "Teste 2",
                        "litres": 131.1
                    },
                    {
                        "country": "Teste 3",
                        "litres": 115.8
                    },
                    {
                        "country": "Teste 4",
                        "litres": 109.9
                    },
                    {
                        "country": "Teste 5",
                        "litres": 108.3
                    },
                    {
                        "country": "Teste 6",
                        "litres": 65
                    },
                    {
                        "country": "Teste 7",
                        "litres": "20"
                    }
                ]
            }
        ); 
        AmCharts.makeChart("chartdiv5",
            {
                "type": "serial",
                "categoryField": "category",
                "autoMarginOffset": 10,
                "marginRight": 10,
                "marginTop": 10,
                "startDuration": 1,
                "fontSize": 13,
                "theme": "light",
                "categoryAxis": {
                    "gridPosition": "start"
                },
                "trendLines": [],
                "graphs": [
                    {
                        "balloonText": "[[title]] of [[category]]:[[value]]",
                        "bullet": "round",
                        "bulletSize": 10,
                        "id": "AmGraph-1",
                        "lineAlpha": 1,
                        "lineThickness": 3,
                        "title": "graph 1",
                        "type": "smoothedLine",
                        "valueField": "column-1"
                    }
                ],
                "guides": [],
                "valueAxes": [
                    {
                        "id": "ValueAxis-1",
                        "title": ""
                    }
                ],
                "allLabels": [],
                "balloon": {},
                "titles": [],
                "dataProvider": [
                    {
                        "category": "1",
                        "column-1": 8,
                        "column-2": 5
                    },
                    {
                        "category": "2",
                        "column-1": 6,
                        "column-2": 7
                    },
                    {
                        "category": "3",
                        "column-1": 2,
                        "column-2": 3
                    },
                    {
                        "category": "4",
                        "column-1": 1,
                        "column-2": 3
                    },
                    {
                        "category": "5",
                        "column-1": 2,
                        "column-2": 1
                    },
                    {
                        "category": "6",
                        "column-1": 3,
                        "column-2": 2
                    },
                    {
                        "category": "7",
                        "column-1": 6,
                        "column-2": 8
                    }
                ]
            }
        );                    
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button.big.green {
        border-color: #30ab4a !important;
    }
    .button.block-mobile.small {
        border: 2px solid #59ba92;
    }    
    .button-menu h1 {
        margin-bottom: 10px;
    }
    .button-menu {
        height: 19vh;
        padding-top: 10px;
        padding-left: 15px;
        padding-right: 15px;
        color: #666;
    }
    h5 {
        line-height: 110%;
        font-weight: 300;
        margin-top: 10px;
        margin-bottom: 20px;
        color: #888;
    }

    h3 i {
        color: #59ba92;
    }

    .menu .button {
        margin-bottom: 0px;
        margin-right: 3px;
    }

    @media only screen and (max-width: 736px) { 
        .menu .button:not(:last-child) {
            border-bottom: 0px !important;
        }
        .menu .button {
            margin-right: 0px !important;
            border-top-right-radius: 0px;
            border-top-left-radius: 0px;
            border-bottom-right-radius: 0px;
            border-bottom-left-radius: 0px;
        }
        .menu .button:first-child {
            border-top-right-radius: 6px !important;
            border-top-left-radius: 6px !important;
        }        
        .menu .button:last-child {
            border-bottom-right-radius: 6px !important;
            border-bottom-left-radius: 6px !important;
        }                
    }    
</style>



// WEBPACK FOOTER //
// src/components/Relatorios.vue